export const AndroidLogo = require('./android.png');
export const AmazonLogo = require('./amazon.png');
export const AppleLogo = require('./apple.png');
